import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryCards from './components/CategoryCards';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { generateSEOData } from '@/components/feature/SEOHead';
import { categories, articles } from '@/mocks/articles';
import { faqs } from '@/mocks/faq';

const seo = generateSEOData({
  title: '典故解析与文化传承',
  description: '黄游下戟，出自中国古代典故，蕴含深厚的历史文化内涵。全面解析黄游下戟的出处、故事背景、文化寓意及其在诗词文学中的传承与应用。',
  canonicalUrl: '/',
});

const siteUrl = 'https://huangyouxiaji.com';

const jsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '黄游下戟文化研究',
      url: siteUrl,
      description: '深耕中国古典文化，以严谨的学术态度和生动的表达方式，为您全面解析黄游下戟这一经典典故。',
    },
    {
      '@type': 'WebSite',
      name: '黄游下戟文化研究',
      url: siteUrl,
      description: '深度解析中国古代典故黄游下戟的出处、背景、寓意与传承。',
      potentialAction: {
        '@type': 'SearchAction',
        target: `${siteUrl}/search?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      name: '黄游下戟 - 首页',
      url: siteUrl,
      description: seo.description,
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: siteUrl },
        ],
      },
    },
    {
      '@type': 'FAQPage',
      mainEntity: faqs.map((faq) => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer,
        },
      })),
    },
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryCards />
        <FeaturedArticles />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}